import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import UserProfile from "../components/UserProfile";
import MyListings from "../components/MyListings";
import Package from "../components/Package";
import API_BASE from "../config/api";
import Dashboard from "../components/Dashboard";
import CommentsReviews from "../components/CommentsReviews";
import UpgradeListing from "../components/UpgradeListing";
import PersonalWebsiteManager from "../components/PersonalWebsiteManager";
import WebAboutMe from "../components/WebAboutMe";
import WebPortfolio from "../components/WebPortfolio";
import WebBiography from "../components/WebBiography";
import WebContactMe from "../components/WebContactMe";
import Wallet from "../components/Wallet";
import SelectBusiness from "../components/SelectBusiness";
import Profile from "../components/Profile";
import BusinessWebsiteManager from "../components/BusinessWebsiteManager";
import PoliticalWebsiteManager from "../components/PoliticalWebsiteManager";
import MyWebsites from "../components/MyWebsites";
import AdminSectionGate from "../components/AdminSectionGate";
import AdminHomepageImages from "../components/AdminHomepageImages";
import AdminAdLeads from "../components/AdminAdLeads";
import AdminAdSegments from "../components/AdminAdSegments";
import AdminBecomeAgent from "../components/AdminBecomeAgent";
import AdminAdvertisement from "../components/AdminAdvertisement";
import AdminServiceInquiries from "../components/AdminServiceInquiries";
import AdminPageManagement from "../components/AdminPageManagement";
import AdminSubdomains from "../components/AdminSubdomains";
import AdminContactMessages from "../components/AdminContactMessages";
import AdminWalletOverview from "../components/AdminWalletOverview";
import AdminRenewalHistory from "../components/AdminRenewalHistory";
import BulkListingUpload from "../components/BulkListingUpload";
import AdminTransferOwnership from "../components/AdminTransferOwnership";




export default function Admin() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const paymentStatus = params.get("payment");
    const listinguidFromUrl = params.get("listinguid") || params.get("userid"); // ← fonepay callback uses "userid"



    const getInitialPage = () => {
        if (paymentStatus === "success" || paymentStatus === "failed") {
            if (params.get("page") === "Wallet") return "Wallet";
            if (listinguidFromUrl) return "UpgradeListing";
        }
        return params.get("page") || "Dashboard";
    };

    const [activePage, setActivePage] = useState(getInitialPage);

    const [username, setUsername] = useState("");
    const [userData, setUserData] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const userid = new URLSearchParams(location.search).get("userid");
    const [selectedListingUid, setSelectedListingUid] = useState(null);

    useEffect(() => {
        const url = new URL(window.location.href);
        if (url.searchParams.get("page") !== activePage) {
            url.searchParams.set("page", activePage);
            window.history.replaceState({}, "", url);
        }
    }, [activePage]);

    useEffect(() => {
        if ((paymentStatus === "success" || paymentStatus === "failed")
            && listinguidFromUrl
            && params.get("page") !== "Wallet") {          // ← added guard
            setSelectedListingUid(listinguidFromUrl);
            setActivePage("UpgradeListing");
            const url = new URL(window.location.href);
            url.searchParams.set("page", "UpgradeListing");
            window.history.replaceState({}, "", url);
        }
    }, [paymentStatus, listinguidFromUrl]);

    useEffect(() => {
        if ((paymentStatus === "success" || paymentStatus === "failed") && params.get("page") === "Wallet") {
            if (listinguidFromUrl) setSelectedListingUid(listinguidFromUrl); // ← also select the right business here
            setActivePage("Wallet");
            const url = new URL(window.location.href);
            url.searchParams.set("page", "Wallet");
            window.history.replaceState({}, "", url);
        }
    }, [paymentStatus, listinguidFromUrl]);

    useEffect(() => {
        const saved = localStorage.getItem("user");
        if (saved) {
            try {
                const u = JSON.parse(saved);
                setUsername(u.fullname ?? "Admin");
            } catch (e) {
                console.error(e);
            }
        }
    }, []);

    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.personaluid;

    const [walletBalance, setWalletBalance] = useState(0);

    // ---- Business switcher (customer with multiple listings) ----
    const [listings, setListings] = useState([]);
    const [listingsLoading, setListingsLoading] = useState(true);
    const [businessChosen, setBusinessChosen] = useState(false);

    useEffect(() => {
        if (!userId) { setListingsLoading(false); return; }
        setListingsLoading(true);
        fetch(`${API_BASE}/api/get_user_listings.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_id: userId }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && Array.isArray(data.listings)) {
                    setListings(data.listings);
                }
            })
            .catch(() => { })
            .finally(() => setListingsLoading(false));
    }, [userId]);


    // Default the active listing once listings load (keeps payment-redirect / last-used)
    useEffect(() => {
        if (listings.length === 0) return;
        setSelectedListingUid((prev) => {
            if (prev && listings.some((l) => l.listinguid === prev)) return prev;
            const saved = localStorage.getItem("activeListingUid");
            if (saved && listings.some((l) => l.listinguid === saved)) return saved;
            return listings[0].listinguid;
        });
    }, [listings]);

    const activeListing = listings.find((l) => l.listinguid === selectedListingUid) || null;

    const handleSelectListing = (listinguid) => {
        setSelectedListingUid(listinguid);
        localStorage.setItem("activeListingUid", listinguid);
    };

    // Always show the chooser on entering the panel; auto-skip ONLY for a single
    // business or when returning from a payment redirect.
    useEffect(() => {
        if (listings.length === 0) return;
        if (listings.length === 1) { setBusinessChosen(true); return; }
        if (listinguidFromUrl) { setBusinessChosen(true); return; }
    }, [listings, listinguidFromUrl]);


    const handleChooseBusiness = (listinguid) => {
        setSelectedListingUid(listinguid);
        localStorage.setItem("activeListingUid", listinguid);
        setBusinessChosen(true);
        setActivePage("Dashboard");
    };

    // ✓ Navbar wallet balance — CR A1: one wallet per LOGIN now, not per
    // business, so this reads the logged-in customer's own wallet
    // regardless of which business is currently selected.
    useEffect(() => {
        if (!userId) return;
        fetch(`${API_BASE}/api/get_wallet.php?user_id=${userId}`)
            .then(res => res.json())
            .then(data => { if (data.success) setWalletBalance(data.balance || 0); })
            .catch(() => { });
    }, [userId]);

    // ✓ Active business's purchased plans (to gate the Website menu, etc.)
    const [activePlans, setActivePlans] = useState([]);
    useEffect(() => {
        if (!selectedListingUid) { setActivePlans([]); return; }
        fetch(`${API_BASE}/api/get_listing_upgrades.php?listinguid=${encodeURIComponent(selectedListingUid)}`)
            .then(res => res.json())
            .then(data => { if (data.success) setActivePlans(data.packages || []); })
            .catch(() => setActivePlans([]));
    }, [selectedListingUid]);

    const hasPortfolioWebsite = activePlans.some(p => p.key === "personal_portfolio");
    const hasBusinessWebsite = activePlans.some(p => p.key === "website_link");
    // U12/U13
    const hasPoliticalWebsite = activePlans.some(p => p.key === "political_website");

    useEffect(() => {
        if (!userid) return;
        fetch(`${API_BASE}/api/userdata.php?userid=${userid}`)
            .then(res => res.json())
            .then(res => res.success && setUserData(res.data))
            .catch(err => console.error(err));
    }, [userid]);

    const handleLogout = () => {
        localStorage.removeItem("user");
        window.location.href = "/";
    };

    // Show the business chooser (with a loader while listings load) when the customer
    // hasn't picked a business yet and either we're still loading or there are multiple.
    if ((listingsLoading || listings.length > 1) && !businessChosen) {
        return (
            <SelectBusiness
                listings={listings}
                userName={username}
                onSelect={handleChooseBusiness}
                loading={listingsLoading}
            />
        );
    }



    return (
        <div className="admin-layout d-flex flex-column vh-100">

            {/* NAVBAR */}
            <nav className="navbar sticky-top custom-navbar px-3">
                <div className="container-fluid d-flex justify-content-between align-items-center">

                    {/* LEFT: toggle + logo + business switcher */}
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn d-md-none mobile-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
                            <i className="bi bi-list"></i>
                        </button>

                        <img src="/logo.png" alt="Logo" className="admin-logo" />

                        {/* BUSINESS SWITCHER */}
                        {listings.length > 0 && (
                            <div className="dropdown business-switcher">
                                <button className="btn switcher-btn d-flex align-items-center gap-2" data-bs-toggle="dropdown">
                                    <i className="bi bi-shop text-primary fs-5"></i>
                                    <span className="switcher-text text-start">
                                        <span className="switcher-name">
                                            {activeListing ? activeListing.title : "Select business"}
                                        </span>
                                        {activeListing && (
                                            <span className="switcher-loc">
                                                {activeListing.province}{activeListing.district ? `, ${activeListing.district}` : ""}
                                            </span>
                                        )}
                                    </span>
                                    <i className="bi bi-chevron-down ms-1 text-muted"></i>
                                </button>

                                <ul className="dropdown-menu shadow-lg animate-dropdown switcher-menu">
                                    <li className="dropdown-header d-flex justify-content-between align-items-center">
                                        <span>Your Businesses</span>
                                        <span className="badge bg-light text-secondary">{listings.length}</span>
                                    </li>
                                    <li><hr className="dropdown-divider" /></li>

                                    {listings.map((l) => (
                                        <li key={l.listinguid}>
                                            <button
                                                className={`dropdown-item switcher-item d-flex align-items-center ${l.listinguid === selectedListingUid ? "active-listing" : ""}`}
                                                onClick={() => handleSelectListing(l.listinguid)}
                                            >
                                                <span className="d-flex flex-column">
                                                    <span className="fw-semibold text-dark">{l.title}</span>
                                                    <small className="text-muted">
                                                        {l.province}{l.district ? `, ${l.district}` : ""}
                                                    </small>
                                                </span>
                                                <span className="ms-auto d-flex align-items-center gap-2">
                                                    {l.states == 1
                                                        ? <span className="badge bg-success">Approved</span>
                                                        : <span className="badge bg-warning text-dark">Pending</span>}
                                                    {l.listinguid === selectedListingUid &&
                                                        <i className="bi bi-check-circle-fill text-primary"></i>}
                                                </span>
                                            </button>
                                        </li>
                                    ))}

                                    <li><hr className="dropdown-divider" /></li>
                                    <li>
                                        <button className="dropdown-item text-primary" onClick={() => setActivePage("MyListings")}>
                                            <i className="bi bi-grid me-2"></i> View all businesses
                                        </button>
                                    </li>
                                    <li>
                                        <a className="dropdown-item text-success" href="/add-listing">
                                            <i className="bi bi-plus-circle me-2"></i> Add new business
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>

                    {/* RIGHT SECTION */}
                    <div className="d-flex align-items-center gap-4">
                        <div className="d-flex align-items-center px-3 py-1 rounded" style={{ background: "#ecfdf5", border: "1px solid #bbf7d0" }}>
                            <i className="bi bi-wallet2 text-success me-2"></i>
                            <span className="fw-semibold text-success">₹ {walletBalance.toLocaleString()}</span>
                        </div>

                        <a href="/add-listing" className="d-flex align-items-center gap-2 text-decoration-none" style={{ cursor: "pointer" }}>
                            <i className="bi bi-plus-circle-fill text-success fs-4"></i>
                            <span className="fw-semibold text-dark">Add Listing</span>
                        </a>

                        {/* Notification Dropdown */}
                        <div className="dropdown">
                            <button className="icon-btn" data-bs-toggle="dropdown"><i className="bi bi-bell-fill"></i></button>
                            <ul className="dropdown-menu dropdown-menu-end shadow-lg animate-dropdown">
                                <li className="dropdown-header fw-semibold text-primary">
                                    <i className="bi bi-bell me-2 text-warning"></i> Notifications
                                </li>
                                <li><hr /></li>
                                <li>
                                    <span className="dropdown-item d-flex align-items-center">
                                        <i className="bi bi-check-circle-fill me-2 text-success"></i> No new notifications
                                    </span>
                                </li>
                            </ul>
                        </div>

                        <style>{`
                            .dropdown-item i { font-size: 1.1rem; }
                            .dropdown-item { padding: 8px 14px; border-radius: 6px; }
                            .dropdown-item:hover { background: #f1f6ff; }
                        `}</style>
                    </div>
                </div>

                {/* NAVBAR CSS */}
                <style>{`
        .custom-navbar { height: 65px; background: #ffffff; border-bottom: 1px solid #e7e7e7; box-shadow: 0 1px 8px rgba(0,0,0,0.06); }
        .admin-logo { height: 50px; transition: 0.3s; }
        @media (max-width: 768px) { .admin-logo { height: 42px; } }
        .mobile-toggle i { font-size: 1.7rem; color: #2563eb; }
        .icon-btn { background: #eef3ff; border: none; padding: 8px 11px; border-radius: 50%; color: #2563eb; transition: 0.2s; }
        .icon-btn:hover { background: #dce8ff; transform: translateY(-2px); }
        .profile-btn { border: none; background: transparent; padding: 0; border-radius: 50%; transition: 0.2s; }
        .profile-btn img { border: 2px solid #e3eaff; box-shadow: 0 0 5px rgba(0,0,0,0.08); }
        .profile-btn:hover img { transform: scale(1.06); border-color: #2563eb; }
        .animate-dropdown { animation: fadeIn 0.25s ease-in-out; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
        .business-switcher .switcher-btn { background: #f6f8ff; border: 1px solid #e3eaff; border-radius: 10px; padding: 4px 12px; max-width: 260px; }
        .business-switcher .switcher-btn:hover { background: #eef3ff; }
        .business-switcher .switcher-text { display: flex; flex-direction: column; line-height: 1.1; min-width: 0; }
        .business-switcher .switcher-name { font-weight: 600; color: #1f2937; font-size: 0.92rem; max-width: 170px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .business-switcher .switcher-loc { font-size: 0.72rem; color: #6b7280; max-width: 170px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .business-switcher .switcher-menu { min-width: 300px; max-height: 420px; overflow-y: auto; padding: 6px 0; }
        .business-switcher .switcher-item { padding: 8px 14px; }
        .business-switcher .switcher-item.active-listing { background: #eef3ff; }
        @media (max-width: 575px) { .business-switcher .switcher-loc { display: none; } .business-switcher .switcher-name { max-width: 110px; } }
    `}</style>
            </nav>

            {/* MAIN */}
            <div className="d-flex flex-grow-1 overflow-hidden">
                {/* SIDEBAR */}
                <div className={`sidebar-container ${sidebarOpen ? "open" : ""}`}>
                    <Sidebar
                        active={activePage}
                        onChange={(p) => { setActivePage(p); setSidebarOpen(false); }}
                        sidebarOpen={sidebarOpen}
                        showWebsite={hasPortfolioWebsite}
                        showBusinessWebsite={hasBusinessWebsite}
                        showPoliticalWebsite={hasPoliticalWebsite}
                        userName={username || userData?.name || userData?.username || "User"}
                        onProfile={() => { setActivePage("UserProfile"); setSidebarOpen(false); }}
                        onLogout={handleLogout}
                    />
                </div>

                {sidebarOpen && <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>}

                {/* CONTENT */}
                <div className="flex-grow-1 bg-light p-4 overflow-auto">
                    {activePage === "Dashboard" && (
                        <Dashboard
                            userData={userData}
                            listinguid={selectedListingUid}
                            businessName={activeListing?.title}
                            onSwitch={() => setBusinessChosen(false)}
                        />
                    )}
                    {activePage === "UserProfile" && <UserProfile userData={userData} />}
                    {activePage === "MyListings" && (
                        <MyListings
                            userData={userData}
                            onUpgrade={(listinguid) => {
                                setSelectedListingUid(listinguid);
                                localStorage.setItem("activeListingUid", listinguid);
                                setActivePage("UpgradeListing");
                            }}
                            onView={(listinguid) => {
                                setSelectedListingUid(listinguid);
                                localStorage.setItem("activeListingUid", listinguid);
                                setActivePage("ViewProfile");
                            }}
                            onReviews={(listinguid) => {
                                setSelectedListingUid(listinguid);
                                localStorage.setItem("activeListingUid", listinguid);
                                setActivePage("CommentsReviews");
                            }}
                        />
                    )}
                    {activePage === "ViewProfile" && (
                        <Profile userData={userData} listinguid={selectedListingUid} />
                    )}

                    {activePage === "CommentsReviews" && <CommentsReviews userData={userData} listinguid={selectedListingUid} />}
                    {activePage === "UpgradeListing" && (<UpgradeListing listinguid={selectedListingUid} personaluid={userId} />)}                    {activePage === "WebAboutMe" && <WebAboutMe userData={userData} />}
                    {activePage === "WebPortfolio" && <WebPortfolio userData={userData} />}
                    {activePage === "WebBiography" && <WebBiography userData={userData} />}
                    {activePage === "WebContactMe" && <WebContactMe userData={userData} />}
                    {activePage === "BusinessWebsite" && (<BusinessWebsiteManager userData={userData} listinguid={selectedListingUid} onBack={() => setActivePage("MyWebsites")} />)}
                    {activePage === "PoliticalWebsite" && (<PoliticalWebsiteManager userData={userData} listinguid={selectedListingUid} onBack={() => setActivePage("MyWebsites")} />)}
                    {activePage === "MyWebsites" && (<MyWebsites hasPersonal={hasPortfolioWebsite} hasBusiness={hasBusinessWebsite} hasPolitical={hasPoliticalWebsite} personaluid={userData?.userselfuid || userId} onManage={(p) => setActivePage(p)} />)}
                    {activePage === "PersonalWebsite" && (<PersonalWebsiteManager userData={userData} onBack={() => setActivePage("MyWebsites")} />)}
                    {activePage === "Wallet" && (<Wallet userData={userData} balance={walletBalance} onBalanceUpdate={setWalletBalance} personaluid={userId} listinguid={selectedListingUid} listings={listings} />)}

                    {activePage === "AdminHomepageImages" && (
                        <AdminSectionGate personaluid={userId}><AdminHomepageImages /></AdminSectionGate>
                    )}
                    {activePage === "AdminAdLeads" && (
                        <AdminSectionGate personaluid={userId}><AdminAdLeads /></AdminSectionGate>
                    )}
                    {activePage === "AdminAdSegments" && (
                        <AdminSectionGate personaluid={userId}><AdminAdSegments /></AdminSectionGate>
                    )}
                    {activePage === "AdminBecomeAgent" && (
                        <AdminSectionGate personaluid={userId}><AdminBecomeAgent /></AdminSectionGate>
                    )}
                    {activePage === "AdminAdvertisement" && (
                        <AdminSectionGate personaluid={userId}><AdminAdvertisement /></AdminSectionGate>
                    )}
                    {activePage === "AdminServiceInquiries" && (
                        // U14: scoped to whichever business is currently switched to
                        <AdminSectionGate personaluid={userId}><AdminServiceInquiries listinguid={selectedListingUid} personaluid={userId} /></AdminSectionGate>
                    )}
                    {activePage === "AdminPageManagement" && (
                        <AdminSectionGate personaluid={userId}><AdminPageManagement /></AdminSectionGate>
                    )}
                    {activePage === "AdminSubdomains" && (
                        <AdminSectionGate personaluid={userId}><AdminSubdomains /></AdminSectionGate>
                    )}
                    {activePage === "AdminContactMessages" && (
                        <AdminSectionGate personaluid={userId}><AdminContactMessages /></AdminSectionGate>
                    )}
                    {activePage === "AdminWalletOverview" && (
                        <AdminSectionGate personaluid={userId}><AdminWalletOverview /></AdminSectionGate>
                    )}
                    {activePage === "AdminRenewalHistory" && (
                        <AdminSectionGate personaluid={userId}><AdminRenewalHistory /></AdminSectionGate>
                    )}
                    {activePage === "BulkUpload" && <BulkListingUpload personaluid={userId} />}
                    {activePage === "AdminTransferOwnership" && (
                        <AdminSectionGate personaluid={userId}><AdminTransferOwnership /></AdminSectionGate>
                    )}
                   
                  
                </div>
            </div>

            {/* SIDEBAR RESPONSIVE CSS */}
            <style>{`
                @media (min-width: 768px) {
                    .sidebar-container { width: 240px; height: calc(100vh - 56px); position: sticky; top: 56px; border-right: 1px solid #ddd; background: #fff; }
                }
                @media (max-width: 768px) {
                    .sidebar-container { width: 240px; position: fixed; top: 0; left: -260px; height: 100%; background: #fff; z-index: 1055; transition: all 0.3s ease; box-shadow: 0 0 15px rgba(0,0,0,0.2); }
                    .sidebar-container.open { left: 0; }
                }
                .sidebar-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.3); z-index: 1050; }
            `}</style>
        </div>
    );
}